export default __webpack_public_path__ + "static/media/Hats02.3bcbd4db.png";